<template>
  <section
    v-if="company"
    class="w-full"
  >
    <h1 class="flex items-center justify-between">
      {{ $t('components.company.performance.title') }}
      <div class="text-sm text-gray-600">
        <button
          class="font-semibold uppercase hover:text-gray-800"
          @click="showCompanyPerformanceEditModal()"
        >
          <fa :icon="faPen" />
          {{ $t('components.company.performanceComponent.edit') }}
        </button>
      </div>
    </h1>

    <h2 class="my-4 text-xl">
      {{ $t('components.company.performanceComponent.facebook') }}
    </h2>
    <div class="flex flex-wrap w-full">
      <div class="flex-col w-full mb-2 lg:w-1/2">
        <data-field
          :label="$t('components.company.performanceComponent.facebookLink')"
          :value="facebook.link"
        />
        <data-field
          :label="$t('components.company.performanceComponent.budget')"
          :value="facebook.budget"
        />
        <data-field
          :label="$t('components.company.performanceComponent.budgetVariable')"
          :value="formatBudgetDistribution(facebook.distributeBudget)"
        />
        <data-field :label="$t('components.company.performanceComponent.zip')">
          {{ formatZip(facebook.zip) }}
        </data-field>
      </div>
    </div>

    <h2 class="my-4 text-xl">
      {{ $t('components.company.performanceComponent.google') }}
    </h2>
    <div class="flex flex-wrap w-full">
      <div class="flex-col w-full mb-2 lg:w-1/2">
        <data-field
          :label="$t('components.company.performanceComponent.googleTarget')"
          :value="google.target"
        />
        <data-field
          :label="$t('components.company.performanceComponent.googleEmail')"
          :value="google.email"
        />
        <data-field
          :label="$t('components.company.performanceComponent.budget')"
          :value="google.budget"
        />
        <data-field
          :label="$t('components.company.performanceComponent.budgetVariable')"
          :value="formatBudgetDistribution(google.distributeBudget)"
        />
        <data-field :label="$t('components.company.performanceComponent.zip')">
          {{ formatZip(google.zip) }}
        </data-field>
      </div>
    </div>
  </section>
</template>

<script>
import EditCompanyPerformanceModal from '@/components/modals/company/performance/edit'
import DataField from '@/components/data-field'
import { faPen } from '@fortawesome/free-solid-svg-icons'

import GET_COMPANY_PERFORMANCE_DATA from '@/graphql/GetCompanyPerformanceData.gql'

export default {
  components: { DataField },
  props: {
    companyId: {
      type: String,
      required: true
    }
  },
  data () {
    return { faPen }
  },
  computed: {
    google () {
      return this.company.performance.google
    },
    facebook () {
      return this.company.performance.facebook
    }
  },
  apollo: {
    company: {
      query: GET_COMPANY_PERFORMANCE_DATA,
      variables () {
        return { id: this.companyId }
      }
    }
  },
  methods: {
    formatZip (zip) {
      return zip.filter(Boolean).join(', ')
    },
    formatBudgetDistribution (value) {
      return value === 'yes' ? this.$t('components.company.performance.yes') : this.$t('components.company.performance.no')
    },
    showCompanyPerformanceEditModal () {
      this.$modal.show(
        EditCompanyPerformanceModal,
        {
          companyId: this.company.id,
          google: { ...this.company.performance.google },
          facebook: { ...this.company.performance.facebook }
        }
      )
    }
  }
}
</script>
